import type { NgDocCategory } from '@ng-doc/core';

const SignalsCategory: NgDocCategory = {
  order: 5,
  title: 'Signals'
};

export default SignalsCategory;